module.exports = __webpack_public_path__ + "img/desarrollo-1.1bac4df6.webp";